/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import React from "react";
import { Setter } from "../../utils/Interfaces";
import { TextField, Typography } from "@mui/material";

export interface ControlledEditableFieldProps<T> {
    value: T;
    setValue: Setter<T>;
    width: number;
    label: string;
    editing: boolean;
    size: "small" | "medium" | undefined;
    typograhyVariant?: "h5" | "h6" | "inherit" | "body1";
    textFieldVariant?: "number" | "inherit";
}

const ControlledEditableField = <T extends Object>(props: ControlledEditableFieldProps<T>) => {
    const { value, setValue, width, label, editing, size, typograhyVariant = "body1", textFieldVariant = "inherit" } = props;

    if (!editing) {
        return <Typography variant={typograhyVariant}>{value.toString()}</Typography>;
    } else {
        return (
            <TextField
                type={textFieldVariant}
                size={size}
                sx={{ width: width }}
                value={value.toString()}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value as unknown as T)}
                label={label}
                name={label.toLowerCase().replaceAll(" ", "_")}
            />
        );
    }
};

export default ControlledEditableField;
